let getRandom = function (min, max) {
  let rand = min - 0.5 + Math.random() * (max - min + 1);
  rand = Math.round(rand);
  return rand;
};

let render = function () {
  $.fn.spinner = function(options) {

    options = $.extend({
      min: 0
    }, options);

    var make = function() {
      var self = $(this),
        $input = self.find('input'),
        $plus = self.find('.js-spinner-plus'),
        $minus = self.find('.js-spinner-minus'),
        min = self.data('min'),
        max = self.data('max');

      function disable() {

        if (parseInt($input.val(), 10) <= min) {
          $minus.addClass('disable');
          $input.val(min)
        } else if (parseInt($input.val(), 10) >= max) {
          $plus.addClass('disable');
        } else {
          $minus.removeClass('disable');
          $plus.removeClass('disable');
        }
      }

      disable();

      $input.val(min).on('keydown', function(e){e.preventDefault()});

      $plus.on('click', function(e) {
        e.preventDefault();
        if(parseInt($input.val(), 10) >= max){
          return false;
        } else {
          $input.val( parseInt($input.val(), 10) + 1);
          disable();
          self.trigger('plus');
          self.trigger('update');
        }
      });
      $minus.on('click', function(e) {
        e.preventDefault();
        if(parseInt($input.val(), 10) <= min){
          return false;
        } else {
          $input.val( parseInt($input.val(), 10) - 1);
          disable();
          self.trigger('minus');
          self.trigger('update');
        }
      });
    }

    return this.each(make);

  };
  
  $('.spinner').spinner();
  $('.scroll2id').mPageScroll2id();
  $('.js-scrollbar').mCustomScrollbar();
  
  function dataPicer() {
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function(inst) {
      $.datepicker._updateDatepicker_original(inst);
      var afterShow = this._get(inst, 'afterShow');
      if (afterShow)
        afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
    }

    $('.js-datepicker').datepicker({
      dateFormat: "yy/mm/dd",
      changeMonth: true,
      changeYear: true,
      afterShow: function (inst) {

            var _dropdown;
            var settings = {autoReinitialise: true};
            $('.ui-datepicker-month, .ui-datepicker-year').styler({
              selectSearch: false,
              onFormStyled: function(){
                _dropdown = $('.jq-selectbox__dropdown');
                _dropdown.find('ul').wrap('<div class="scroll-pane" ></div>');
              },
              onSelectOpened: function(){
                var _ul = $(this).find('.jq-selectbox__dropdown ul');
                var height = _ul.height();
                var _srollPane = _dropdown.find('.scroll-pane');
                _srollPane.height(height);
                _ul.css('max-height', 'none');
                _srollPane.jScrollPane(settings);
              }
            });

      }
    });
  }
  dataPicer();
  
  
  autosize($('.auto-size'));    
};

export {getRandom, render}
